import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { Subject, Observable, of, concat } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, filter, map } from 'rxjs/operators';
import { ToolSettingsService } from 'src/app/service/tool-settings/tool-settings.service';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import {
  AssignmentTypeModel,
  AssignmentTypeParams,
  AssignmentGroups,
  FacilityModel,
  FacilityParams,
  JobParams,
  OwnerParams,
  ShopParams,
  UserParams,
  VendorParams,
  JobModel,
  AutoCompleteSelectModel,
} from '../../tool-transfer/tool-transfer.model';

@Component({
  selector: 'app-tool-transfer-autocomplete-search',
  templateUrl: './tool-transfer-autocomplete-search.component.html',
  styleUrls: ['./tool-transfer-autocomplete-search.component.scss'],
})
export class ToolTransferAutocompleteSearchComponent {
  searchParams: ToolSearchParams;
  jobs;
  @Input() pagination;
  jobsBuffer = [];
  itemBuffer = [];
  selectedItems: any = [];
  jobsBuffer$: Observable<any>;
  itemBuffer$: Observable<any>;
  selectedJobs: any = [];
  input$ = new Subject<string>();
  inputBox$ = new Subject<string>();
  loading: Boolean = false;
  inputLoading: Boolean = false;
  params;
  @Input() dropdownType;
  @Input() id;
  @Input() inputItems: any;
  @Input() label: string;
  @Input() model: string;
  @Input() propertyName: string;
  @Input() type: string;
  @Input() bindLabel: string;
  @Input() refreshOnClose: boolean = true;
  jobParams = JobParams;
  ownerParams = OwnerParams;
  facilityParams = FacilityParams;
  userParams = UserParams;
  shopParams = ShopParams;
  vendorParams = VendorParams;

  // @Output() filter: EventEmitter<Array<Number>> = new EventEmitter<Array<Number>>()
  @Output() filter = new EventEmitter<AutoCompleteSelectModel>();

  @ViewChild('SelectId') public select;

  constructor(
    private toolsService: ToolsService,
    private toolSettingsService: ToolSettingsService,
    private localStorageService: LocalstorageService,
  ) {}

  changeJobDropdown(e) {
    if (this.selectedJobs) {
      const selectedJob = {
        item: e,
        id: this.id,
      };
      this.filter.emit(selectedJob);
    } else {
      this.getJobs();
      this.filter.emit({ id: this.id, item: null });
    }
  }

  changeFn(e) {
    if (this.selectedItems) {
      const selectedItem = {
        item: e,
        id: this.id,
      };
      this.filter.emit(selectedItem);
      return;
    }

    this.refreshDropdown();
  }

  trackByFn(item) {
    return item.id;
  }

  setSearch(id) {
    this.selectedItems = id;
    this.fetchMoreItems(id);
  }

  ngOnChanges(changes) {
    if (this.model === 'jobs') this.getJobs();
    else this.searchItem();
  }

  getJobs() {
    this.searchParams = this.paramsMap[this.model];
    let toolFilter = JSON.parse(this.localStorageService.getItem('toolFilter'));
    this.selectedJobs = toolFilter && toolFilter['scope[job]'] ? toolFilter['scope[job]'].split(',') : [];
    this.toolsService.list['jobs'](this.searchParams).subscribe(res => {
      this.jobs = res.data;
      this.pagination = res.pagination;
      this.searchJobs();
    });
  }

  fetchMore() {
    this.loading = true;
    let params = this.paramsMap[this.model];
    const page = this.pagination.nextPage;
    params = { ...params, page };
    if (this.pagination.nextPage === this.pagination.currentPage) return;
    this.toolsService.list['jobs'](params).subscribe(res => {
      this.loading = false;
      this.jobs = this.jobs.concat(res.data);
      this.pagination = res.pagination;
      this.jobsBuffer = this.jobsBuffer.concat(res.data);
      this.jobsBuffer$ = of(this.jobsBuffer);
    });
  }

  searchJobs(event = null) {
    this.jobsBuffer = this.jobs.slice(0, 50);
    this.jobsBuffer$ = of(this.jobsBuffer);
    this.input$
      .pipe(
        tap(() => (this.loading = true)),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(term =>
          this.toolsService.list['jobs']({
            ...this.searchParams,
            search: term || '',
          }),
        ),
      )
      .subscribe(res => {
        this.loading = false;
        this.pagination = res.pagination;
        this.jobsBuffer = res.data;
        this.jobsBuffer$ = of(this.jobsBuffer);
      });
  }

  scrollToEnd() {
    this.fetchMore();
  }

  refreshDropdown() {
    if (!this.refreshOnClose) return;
    const params = this.paramsMap[this.model];
    const page = 1;
    this.toolsService.list[this.model]({ ...params, page }).subscribe((res: any) => {
      this.loading = false;
      this.pagination = res.pagination;
      this.itemBuffer = res.data;
      this.itemBuffer$ = of(res.data);
    });
  }

  searchItem(event = null) {
    let params = this.paramsMap[this.model];
    let page = this.pagination.nextPage ? this.pagination.nextPage : 1;
    params = { ...params, page: 1 };
    this.itemBuffer$ = of(this.inputItems);
    this.inputBox$
      .pipe(
        tap(() => (this.inputLoading = true)),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(term => this.toolsService.list[this.model]({ ...params, search: term || '' })),
      )
      .subscribe((res: any) => {
        this.inputLoading = false;
        this.pagination = res ? res.pagination : 1;
        this.itemBuffer = res.data;
        this.itemBuffer$ = of(this.itemBuffer);
      });
  }

  fetchMoreItems(idToFind = undefined) {
    if (this.pagination.nextPage === this.pagination.currentPage) return;
    this.inputLoading = true;
    let params = this.paramsMap[this.model];
    const page = this.pagination.nextPage;
    params = { ...params, page };
    this.toolsService.list[this.model](params).subscribe(res => {
      this.inputLoading = false;
      this.inputItems = this.inputItems.concat(res.data);
      this.pagination = res.pagination;
      this.itemBuffer = this.itemBuffer.concat(res.data);
      this.itemBuffer$ = of(this.itemBuffer);
      if (idToFind && !this.inputItems.find(item => item.id == idToFind)) this.fetchMoreItems(idToFind);
    });
  }

  get paramsMap() {
    return {
      jobs: {
        ...this.jobParams,
        'scope[status]': 1,
        'scope[excludeOverheadJobs]': true,
      },
      owners: this.ownerParams,
      facilities: this.facilityParams,
      users: this.userParams,
      shops: this.shopParams,
      vendors: this.vendorParams,
    };
  }
}
